import BasicResource from '@/api/resource';

class ForeignLeadsCampaignsResource extends BasicResource {
    constructor () {
        super('foreign-leads/campaigns');
    }

    pause (campaignId) {
        return this.client.request({
            method: 'PUT',
            path: `/upyield/v1/foreign-leads/campaigns/${campaignId}/pause`,
        });
    }

    unpause (campaignId) {
        return this.client.request({
            method: 'PUT',
            path: `/upyield/v1/foreign-leads/campaigns/${campaignId}/unpause`,
        });
    }

    sync (campaignId) {
        return this.client.request({
            method: 'PUT',
            path: `/upyield/v1/foreign-leads/campaigns/${campaignId}/sync`,
        });
    }
}

export default new ForeignLeadsCampaignsResource;